import { store } from '@betacrew/jars-flux'
import { PAGE_STATE, RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT } from '../../constants/constants';
import { CHOOSE_METHOD_CARD_NAMES } from '../addpayernew/createone/getmethod/constants/constants';
import { ADD_RECIPIENT_INITIAL_STATE } from './constant';
import { TIN_FORMAT_REGEX } from '../../../../libs/utility/constants';
// import { CHOOSE_METHOD_CARD_NAMES } from '../../payerssection/addpayer/createone/getmethod/constants/constants';

export const componentKey = "NEW_RECIPIENT/ADD";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setMethodType: (state, action) => {
            state.methodType = action.payload;
        },
        setRequestType: (state, action) => {
            state.RequestType = action.payload;
            state.recipientBasicInfo.allRequiredFieldsTouched = false;
            state.recipientAddressInformation.allRequiredFieldsTouched = false;
            state.recipientOptionalInformation.allRequiredFieldsTouched = false;

            if (state.RequestType) {
                Object.entries(state.recipientBasicInfo).map(([key, value]) => {
                    if (typeof state.recipientBasicInfo[key] == "object" && key != "RecipientEmail") {

                        const recipientBasicInfo = {
                            ...state.recipientBasicInfo,
                            [key]: {
                                ...state.recipientBasicInfo[key],
                                ...value,
                                rules: { ...(state?.recipientBasicInfo[key]?.rules || {}) ,required: false },
                                errors: {}
                            },
                        };

                        state.recipientBasicInfo = recipientBasicInfo
                    }
                });

                state.recipientAddressInformation = {
                    ...state.recipientAddressInformation, RecipientAddress: {
                        value: state.recipientAddressInformation['RecipientAddress'].value,
                        errors: {},
                        rules: { ...state.recipientAddressInformation['RecipientAddress'].rules, required: false }
                    },
                }
            }

        },
        setRecipientType: (state, action) => {
            state.RecipientType = action.payload;
        },
        setRecipientBasicInformation: (state, action) => {
            let recipientBasicInfo = { ...state.recipientBasicInfo };

            Object.entries(action.payload).map(([key, value]) => {
                recipientBasicInfo = {
                    ...state.recipientBasicInfo,
                    [key]: (typeof state.recipientBasicInfo[key] === 'object' && typeof value === 'object')
                    ? { ...state.recipientBasicInfo[key], ...value }
                    : value,
                };

                state.recipientBasicInfo = recipientBasicInfo;
            })
        },
        setRecipientBasicInformationFieldsTouched: (state, action) => {
            state.recipientBasicInfo.allRequiredFieldsTouched = action.payload;
        },
        setRecipientAddressInformation: (state, action) => {
            let recipientAddressInformation = { ...state.recipientAddressInformation };

            Object.entries(action.payload).map(([key, value]) => {
                recipientAddressInformation = {
                    ...state.recipientAddressInformation,
                    [key]: {
                        ...state.recipientAddressInformation[key],
                        ...value
                    },
                };

                state.recipientAddressInformation = recipientAddressInformation;
            })

            // if country is updated then set the RecipientState to the initial value
            if (action.payload?.RecipientCountry?.value) {
                state.recipientAddressInformation.RecipientState = { ...state.recipientAddressInformation.RecipientState, label: "", value: "" };
                state.recipientAddressInformation.RecipientZIP.value = "";
                if (action.payload.RecipientCountry?.value !== "US") {
                    state.zipCodeValidationSuccess = true;
                } else {
                    state.zipCodeValidationSuccess = false;
                }
            }

            if (action.payload?.RecipientState?.value && state.recipientAddressInformation.RecipientZIP.value && state.recipientAddressInformation.RecipientCountry.value == "US") {
                state.zipCodeValidationSuccess = false;
            }

        },
        setRecipientAddressInformationFieldsTouched: (state, action) => {
            state.recipientAddressInformation.allRequiredFieldsTouched = action.payload;
        },
        setZipCodeValidationSuccess: (state, action) => {
            state.zipCodeValidationSuccess = action.payload
        },
        setRecipientOptionalInformation: (state, action) => {
            let recipientOptionalInformation = { ...state.recipientOptionalInformation };

            Object.entries(action.payload).map(([key, value]) => {
                recipientOptionalInformation = {
                    ...state.recipientOptionalInformation,
                    [key]: {
                        ...state.recipientOptionalInformation[key],
                        ...value
                    },
                };

                state.recipientOptionalInformation = recipientOptionalInformation;
            })
        },
        setRecipientOptionalInformationFieldsTouched: (state, action) => {
            state.recipientOptionalInformation.allRequiredFieldsTouched = action.payload
        },
        setRecipientCreationSuccess: (state, action) => {
            state.recipientCreationSuccessful = action.payload
        },
        setTinNotProviderState: (state, action) => {
            state.recipientBasicInfo.tinNotProvided = action.payload;
            state.recipientBasicInfo.RecipientTIN = { value: "", errors: {}, rules: { required: false, regex: { pattern: TIN_FORMAT_REGEX, message: "Please enter valid TIN" } } }
        },
        setSearchOption: (state, action) => {
            state.searchOption = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setRecipientEditSuccessfull: (state, action) => {
            state.recipientEditedSuccessful = action.payload
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setSelectedRecipient: (state, action) => {
            state.selectedRecipient = action.payload;
        },
        setRecipientDetailId: (state, action) => {
            state.RecipentDetailId = action.payload;
        },
        resetAddRecipientSlice: (state, action) => {
            Object.assign(state, ADD_RECIPIENT_INITIAL_STATE);

            let recipientOptionalInformation = { ...state.recipientOptionalInformation };

            recipientOptionalInformation.Isrecipientclient = {
                value: "",
                errors: {},
                rules: { required: action?.payload?.IsRecipientClient ? true : false, maxLength: 40, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT } }
            }

            state.recipientOptionalInformation = recipientOptionalInformation;
        },
        setSubmittedRecipient: (state, action) => {
            state.submittedRecipient = action.payload
        },
        setW8W9Fees: (state, action) => {
            state.W8W9Fees = action.payload;
        },
    },
    initialReducerState: ADD_RECIPIENT_INITIAL_STATE
});

export const { setLoadingState, setMethodType, setRecipientType, setRequestType, setRecipientBasicInformation, setRecipientBasicInformationFieldsTouched, setRecipientAddressInformation, setRecipientAddressInformationFieldsTouched, setZipCodeValidationSuccess, setRecipientOptionalInformation, setRecipientOptionalInformationFieldsTouched, setRecipientCreationSuccess, setTinNotProviderState, setSearchOption, setPaginationState, setRecipientEditSuccessfull, setSelectedPayer, setSelectedRecipient, setRecipientDetailId, resetAddRecipientSlice, setSubmittedRecipient, setW8W9Fees } = actions;
